<template>
	<div class="form-group required">
        <label for="shortname" class="col-sm-2 control-label">Short Name</label> 
        <div class="col-sm-10">
            <input type="text" id="shortname" placeholder="Short Name" name="shortname" value="360" required="required" class="form-control">
        </div>
    </div>
</template>

<script>
    export default {
    	data() {
    		return {
    			product: 'boots',
    			stock_count: 16
    		}
    	},
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>

<style>
.greeting {
  color: red;
  font-weight: bold;
}
</style>